export default function ElectricBlanket(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.375" y="9" width="23.625" height="15.75" rx="1.6875" stroke="black" stroke-width="1.6875" />
            <path
                d="M6.75 21.375V13.5C6.75 12.8787 7.25368 12.375 7.875 12.375H9C9.62132 12.375 10.125 12.8787 10.125 13.5V20.25C10.125 20.8713 10.6287 21.375 11.25 21.375H12.375C12.9963 21.375 13.5 20.8713 13.5 20.25V13.5C13.5 12.8787 14.0037 12.375 14.625 12.375H15.75C16.3713 12.375 16.875 12.8787 16.875 13.5V20.25C16.875 20.8713 17.3787 21.375 18 21.375H19.125C19.7463 21.375 20.25 20.8713 20.25 20.25V13.5C20.25 12.8787 20.7537 12.375 21.375 12.375H22.5C23.1213 12.375 23.625 12.8787 23.625 13.5V21.375"
                stroke="black"
                stroke-width="1.6875"
                stroke-linecap="round"
            />
            <path
                d="M7.875 24.075V27C7.875 27.6213 8.37868 28.125 9 28.125H29.8125C30.4338 28.125 30.9375 27.6213 30.9375 27V18"
                stroke="black"
                stroke-width="1.6875"
            />
            <rect x="28.6875" y="9.5625" width="4.5" height="7.875" rx="0.5625" fill="black" stroke="black" stroke-width="1.125" />
            <path
                d="M31.7812 12.0938C31.7812 12.5597 31.4035 12.9375 30.9375 12.9375C30.4715 12.9375 30.0938 12.5597 30.0938 12.0938C30.0938 11.6278 30.4715 11.25 30.9375 11.25C31.4035 11.25 31.7812 11.6278 31.7812 12.0938Z"
                fill="white"
            />
            <circle cx="30.9375" cy="15.1875" r="0.5625" fill="white" />
        </svg>
    );
}
